import { Container, Row, Col, Button, Form } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import React, { useEffect, useState } from "react";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import questionnaire_icon from "../../../images/Questionnaire_icon.png";
import Header from "../../Includes/Header";
import { reduxForm, InjectedFormProps } from "redux-form";
import { setwizardPageNumber, setQuestionnaireScreen3 } from "../../authslice";
import { connect, useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import BackButton from "../../Includes/BackButton";
import { ToastBox } from "MyComponents/Toaster";
import { updatePersonalKycDraftStep } from "Utils/personalKycDraft";
import { useTranslation } from "react-i18next";

interface Props { }

const industries = [
  "Agriculture",
  "Arts & Media",
  "Automotive",
  "Casinos & Gambling",
  "Construction & Real Estate",
  "Education",
  "Energy & Utilities",
  "Financial Services",
  "Food & Beverage",
  "Gaming",
  "Government & Public Sector",
  "Healthcare & Pharmaceuticals",
  "Hospitality & Tourism",
  "Import & Export",
  "Information Technology",
  "Legal Services",
  "Logistics & Transportation",
  "Manufacturing",
  "Media & Entertainment",
  "Mining & Natural Resources",
  "Non-Profit & Charity",
  "Retail & E-Commerce",
  "Telecommunications",
  "Other",
];

const Questionnaire_Screen3: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const [selectedIndustry, setSelectedIndustry] = useState<string>("");
  const [industryValidation, setIndustryValidation] = useState(false);
  const page = useSelector((state: RootState) => state.auth.wizardPageNumber);
  const questionnaireScreen3 = useSelector((state: RootState) => state.auth.questionnaireScreen3);
  const userID = useSelector((state: RootState) => state.auth.userID);

  useEffect(() => {
    if (questionnaireScreen3) {
      setSelectedIndustry(questionnaireScreen3);
    }
  }, [questionnaireScreen3]);

  const handleIndustrySelection = (industry: string) => {
    setIndustryValidation(false);
    setSelectedIndustry(industry);
  };

  const submitForm = () => {
    if (!selectedIndustry) {
      setIndustryValidation(true);
      return;
    }

    dispatch(setQuestionnaireScreen3(selectedIndustry));
    dispatch(setwizardPageNumber(page + 1));
    localStorage.setItem('pageNumber', `${page + 1}`);

    if (userID) {
      updatePersonalKycDraftStep(userID, 'questionnaire', { screen3: selectedIndustry });
      updatePersonalKycDraftStep(userID, 'wizardState', { pageNumber: page + 1 });
    }
  };

  return (
    <>
      <ToastBox />
      <Container fluid className="px-0 px-md-3">
        <Row className="g-0">
          <Col md={12} className="mx-auto px-2 pt-0 pb-3">
            <div className="mt-5">
              <Row className="px-2 px-md-5">
                <Col md={12}><BackButton /></Col>
              </Row>
              <Row className="px-2 px-md-5">
                <Col md={12}>
                  <div className="d-flex align-items-start py-3">
                    <img src={questionnaire_icon} width={48} className="d-none d-md-block me-3 mt-1" alt="Questionnaire Icon" />
                    <div>
                      <h3 className="text-start m-0">{t('kyc.questionnaire')}</h3>
                      <p className="fw-normal text-secondary m-0 mt-1 text-nowrap">{t('kyc.individual_form')}</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="px-2 px-md-5">
                <Col md={12}>
                  <div className="d-none d-md-flex align-items-center">
                    <ProgressBar variant="primary" className="custom_progressbar mr-2" now={30} />
                    <p className="fw-bold small py-3 px-3 m-0">3/7</p>
                  </div>
                  <p className="fw-bold text-start mt-4 m-0">{t('kyc.industry_q')}</p>
                  <p className="text-secondary text-start small mt-1">{t('kyc.q3_desc')}</p>

                  <Form noValidate onSubmit={handleSubmit(submitForm)}>
                    <Row className="mt-4 text-start">
                      <Col md={5}>
                        <p className="fs-6 fw-medium">{t('kyc.select_industry')}</p>
                        <div className="dropdown">
                          <Button
                            className={`form-control form-select text-start px-3 rounded-5 border bg-white text-secondary ${industryValidation ? "border-danger" : ""}`}
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            variant=""
                          >
                            {selectedIndustry || t('kyc.select_industry_ph')}
                          </Button>
                          <ul className="dropdown-menu w-100 rounded-4 hide-scroll border-0 shadow">
                            {industries.map((industry) => (
                              <li
                                key={industry}
                                className="dropdown-item"
                                onClick={() => handleIndustrySelection(industry)}
                              >
                                {industry}
                              </li>
                            ))}
                          </ul>
                        </div>
                        {industryValidation && (
                          <small className="text-danger">{t('kyc.industry_required')}</small>
                        )}
                      </Col>
                    </Row>
                    <Row className="mt-4 text-start">
                      <Col md={12}>
                        <Button type="submit" className="btn btn-primary rounded-5" style={{ width: "220px" }}>
                          {t('common.next')}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  form: "wizard",
  enableReinitialize: true,
})(Questionnaire_Screen3);

export default connect(null)(form);
